import anime from 'animejs';

import HamburgerMenu from './HamburgerMenu';
import { EVENTS } from '../config/constants';

export default class HamburgerMenuAnimated extends HamburgerMenu {
  constructor(props) {
    super(props);
    this.events = EVENTS.HAMBURGER;
    this.durations = {
      transform: 360,
      opacity: 460,
    };
  }

  init() {
    super.init();

    Object.values(this.events).forEach(this.watchEvent.bind(this));
  }

  watchEvent(event) {
    window.addEventListener(event, this.handleEvent.bind(this));
  }

  handleEvent({ type }) {
    const [eventName] = Object.entries(this.events).find(([eventName, event]) => event === type);

    if (eventName === 'SHOW') {
      this.animeShowMenu();
      return;
    }

    this.animeHideMenu();
  }

  animeShowMenu() {
    this.animeMenu({ translateY: ['100%', 0], opacity: [0, 1] });
  }

  animeHideMenu() {
    this.animeMenu({ translateY: [0, '100%'], opacity: [1, 0] });
  }

  animeMenu({ translateY, opacity }) {
    anime({
      targets: this.navEl,
      translateY: {
        value: translateY,
        duration: 360,
        easing: 'easeInOutSine',
      },
      opacity: {
        value: opacity,
        duration: 460,
        easing: 'easeInOutSine',
      },
    });
  }
}
